import { z } from "zod";

import { constantsData } from "@/data";

export const setupOnlineDataSourceFormSchema = z.object({
    account: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    id: z.string().optional(),
    name: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
});
